/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Sub_Plan_Card_PricingInputs */



/**
* | output |
* | --- |
* | "Pay-per-use, no pool" |
*
* @param {Gateway_Sub_Plan_Card_PricingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_sub_plan_card_pricing = /** @type {((inputs?: Gateway_Sub_Plan_Card_PricingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Sub_Plan_Card_PricingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nutzungsabhängig, kein Pool")
	return /** @type {LocalizedString} */ ("Pay-per-use, no pool")
});